module.exports = __webpack_public_path__ + "static/media/partner-05.cd377c75.jpg";